/* eslint-disable security/detect-object-injection */
import React, { useContext, useEffect, useRef } from 'react';
import AnimatedPageFade from '../../components/Animations/AnimatedPageFade';
import ApplicationContext from '../../context/ApplicationContext';
import { documentsLanguageContent } from './documentsLanguageContent';

function Documents() {
    const { selectedLanguage, sessionData } = useContext(ApplicationContext);

    const carouselRef = useRef(null);
    const ref=useRef(null);
    const targetRef = useRef(null);

    useEffect(() => {
        if(carouselRef.current){
            setTimeout(() => {
                let element = document.querySelector(`[data-scroll-into="scroll-date"]`);
                if (element) {
                    const scrollLeft = element?.offsetLeft - 500;
                    carouselRef.current.scrollLeft = scrollLeft;
                }
            },1500);
        }

        if(targetRef.current) {
            setTimeout(() => {
                targetRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
                targetRef.current.scrollLeft += 500;
            }, 500);
        }
    }, [sessionData]);

    return (
        <AnimatedPageFade className='flex flex-col justify-between relative h-welcome gradient-bg rounded-[16px] overflow-hidden'>
            <div className='pb-[8px] px-[8px]'>
                <div className='text-start font-semibold text-[#64A003] text-[24px] pt-[8px] lg:text-[26px] xl:text-[32px] 2xl:text-[38px] flex items-center pb-[13px] justify-between pr-8'>
                    <div className='flex items-center w-[60%]'>
                        <img src="/images/Doc.svg" alt="doc" />
                        {documentsLanguageContent['documents'][selectedLanguage]}
                    </div>
                    <div ref={carouselRef} className='flex max-w-[31%] overflow-hidden'>
                        {sessionData && [...Array(sessionData.documents_count)].map((item, index) => (
                            <span ref={sessionData?.document_session?.document_index === index + 1 ? targetRef : ref} className={`${sessionData?.document_session?.document_index === index + 1 ? 'bg-[#797979]' : 'bg-[#007EB4]'} 
                            rounded-[50%] py-0.5 px-2 text-sm text-[#F2F2F2] ml-2`} key={`count-${index}`}>{index + 1}</span>
                        ))}
                    </div>
                </div>
            </div>
        </AnimatedPageFade>
    );
}

export default Documents;